import auth from '../apis/auth';
// import { stopSubmit } from 'redux-form';
import { 
    FETCH_USERS,
    UPDATE_USER,
    SHOW_ERROR
} from './types';
// import errorObject from '../components/helpers/errorObject';

export const fetchUsers = () => async dispatch => {
    await auth.get('/api/users/get_users')
        .then(response =>{
            dispatch({ type: FETCH_USERS, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })
}

export const toggleAccess = (id) => async dispatch => {
    await auth.post('/api/users/access_user', id)
        .then(response => {
            dispatch({ type: UPDATE_USER, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })        
}

export const editScopes = (values) => async dispatch => {
    await auth.post('/api/users/update_scopes', values)
        .then(response => {
            dispatch({ type: UPDATE_USER, payload: response.data})
        })
        .catch(error => {
            dispatch({ type: SHOW_ERROR, payload: error.response.data });
        })        
}